import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import { connect } from 'react-redux';
import { IVAssociationFields, ITarget } from '../../../types/interfaces';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { useAlert } from "react-alert";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowDown, faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import ReactTooltip from 'react-tooltip';
import NumberFormat from 'react-number-format';
import Association from '../../consultation/Association';

const VAssociationFields = ({ 
  idValue,
  selectedBien,
  selectedFloor,
  setSelectedFloor,
  selectedDivisionType,
  setSelectedDivisionType,
  selectedDivisionPercent,
  setSelectedDivisionPercent,
  etageValue,
  setEtageValue,
  typeValue,
  setTypeValue,
  positionValue,
  setPositionValue,
  commentValue,
  setCommentValue,
  percentValue,
  setPercentValue,
  superficieValue,
  setSuperficieValue,
  prixpartValue,
  setPrixpartValue,
  isDoa,
  isDoaAnswer,
  isEdit
 }: IVAssociationFields) => {
  const typeOptions = [{value: "APPARTEMENT", label: "Appartement"}, {value: "MAGASIN", label: "Magasin"}];
  const [percentLimitValue, setPercentLimitValue] = useState(0);
  const [percentLimitEditValue, setPercentLimitEditValue] = useState(0);
  const [percentFlag, setPercentFlag] = useState(false);
  const [superficieFlag, setSuperficieFlag] = useState(false);
  const [prixpartFlag, setPrixpartFlag] = useState(false);
  const percentRef = useRef<HTMLInputElement>(document.createElement("input"));
  const superficieRef = useRef<HTMLInputElement>(document.createElement("input"));
  const prixpartRef = useRef<HTMLInputElement>(document.createElement("input"));
  
  const [divisionTypesDisabled, setDivisionTypesDisabled] = useState(false);
  // const percentOptions = (selectedDivisionType?.division_partition_type_percents || []).filter((e, i, a) => e !== a.find(t => t.p === 6) || a.findIndex(t => t.p === 6) !== i).filter((e, i, a) => i === 0 || a.findIndex(t => t.percent === e.percent) === i).map(e => ({value: e, label: `${e?.percent || "-"}%`}))
  const [percentOptions, setPercentOptions] = useState<any[]>([])

  const alert = useAlert();
  
  // const etageOptions: any[] = [];//selectedBien ? banks.map(e => ({value: e, label: e.fullname}));
  // if(selectedBien && !isNaN(selectedBien["ETAGE_ASS"])){
  //   for(let i = 0; i < Number(selectedBien["ETAGE_ASS"]); i++)
  //     if(!selectedBien.contrat || (selectedBien.contrat?.associations?.length && (!selectedBien.contrat.associations.find(e => e.ETAGE == i) || (selectedBien.contrat.associations.find(e => e.ETAGE == i) && selectedBien.contrat.associations.reduce((n, t) => {
  //       return t.POURCENTAGE && t.ETAGE == i ? n + Number(t.POURCENTAGE) : n
  //     }, 0) < 100))))
  //       etageOptions.push({value: i, label: `${i === 0 ? "RDC" : i} (${100 - (!selectedBien.contrat ? 0 : selectedBien.contrat.associations.reduce((n, t) => {
  //         return t.POURCENTAGE && t.ETAGE == i ? n + Number(t.POURCENTAGE) : n
  //       }, 0))}% disponible)`})
  // }
  
  const [etageOptions, setEtageOptions] = useState<any[]>([]);//selectedBien ? banks.map(e => ({value: e, label: e.fullname}));
  useEffect(() => {
    const etageOptionsTemp: any[] = [];
    if(selectedBien?.division?.division_floors){
      const floors = selectedBien.division.division_floors.sort((e, t) => e.floor - t.floor)
      for(let dFloor of floors)
        if(!selectedBien.contrat || (!selectedBien.contrat?.associations?.length || (!selectedBien.contrat.associations.find(e => e.ETAGE == dFloor.floor) || (selectedBien.contrat.associations.find(e => e.ETAGE == dFloor.floor) && selectedBien.contrat.associations.reduce((n, t) => {
          return t.POURCENTAGE && t.ETAGE == dFloor.floor ? n + Number(t.POURCENTAGE) : n
        }, 0) < 100))))
          etageOptionsTemp.push({value: dFloor, label: `${dFloor.floor === 0 ? "RDC" : dFloor.floor} (${100 - (!selectedBien.contrat ? 0 : selectedBien.contrat.associations.reduce((n, t) => {
            return t.POURCENTAGE && t.ETAGE == dFloor.floor ? n + Number(t.POURCENTAGE) : n
          }, 0))}% disponible)`})
    }
    else if(selectedBien && !isNaN(selectedBien["ETAGE_ASS"])){
      for(let i = 0; i < Number(selectedBien["ETAGE_ASS"]); i++)
        if(!selectedBien.contrat || (!selectedBien.contrat?.associations?.length || (!selectedBien.contrat.associations.find(e => e.ETAGE == i) || (selectedBien.contrat.associations.find(e => e.ETAGE == i) && selectedBien.contrat.associations.reduce((n, t) => {
          return t.POURCENTAGE && t.ETAGE == i ? n + Number(t.POURCENTAGE) : n
        }, 0) < 100))))
          etageOptionsTemp.push({value: {floor: i}, label: `${i === 0 ? "RDC" : i} (${100 - (!selectedBien.contrat ? 0 : selectedBien.contrat.associations.reduce((n, t) => {
            return t.POURCENTAGE && t.ETAGE == i ? n + Number(t.POURCENTAGE) : n
          }, 0))}% disponible)`})
    }
    setEtageOptions(etageOptionsTemp);
  }, [selectedBien])
  // useEffect(() => {
  //   const etageOptionsTemp: any[] = [];
  //   if(selectedBien && !isNaN(selectedBien["ETAGE_ASS"])){
  //     for(let i = 0; i < Number(selectedBien["ETAGE_ASS"]); i++)
  //       if(!selectedBien.contrat || (!selectedBien.contrat?.associations?.length || (!selectedBien.contrat.associations.find(e => e.ETAGE == i) || (selectedBien.contrat.associations.find(e => e.ETAGE == i) && selectedBien.contrat.associations.reduce((n, t) => {
  //         return t.POURCENTAGE && t.ETAGE == i ? n + Number(t.POURCENTAGE) : n
  //       }, 0) < 100))))
  //         etageOptionsTemp.push({value: i, label: `${i === 0 ? "RDC" : i} (${100 - (!selectedBien.contrat ? 0 : selectedBien.contrat.associations.reduce((n, t) => {
  //           return t.POURCENTAGE && t.ETAGE == i ? n + Number(t.POURCENTAGE) : n
  //         }, 0))}% disponible)`})
  //   }
  //   setEtageOptions(etageOptionsTemp);
  // }, [selectedBien])
  
  useEffect(() => {
    //(selectedDivisionType?.division_partition_type_percents || []).filter((e, i, a) => e !== a.find(t => t.p === 6) || a.findIndex(t => t.p === 6) !== i).filter((e, i, a) => i === 0 || a.findIndex(t => t.percent === e.percent) === i).map(e => ({value: e, label: `${e?.percent || "-"}%`}))
    const percents: any[] = [...(selectedDivisionType?.division_partition_type_percents || [])]
    if(selectedFloor?.division_parts?.length){
      for(let i in selectedFloor.division_parts)
        percents.splice(percents.findIndex(e => e.percent === selectedFloor.division_parts[i].percent), 1)
    }
    setPercentOptions(percents.sort((e, t) => e.percent - t.percent).filter((e, i, a) => i === 0 || a.findIndex(t => t.percent === e.percent) === i).map(e => ({value: e, label: `${e?.percent || "-"}%`})));
  }, [selectedFloor, selectedDivisionType])

  useEffect(() => {
    // console.log("detected", selectedFloor, isEdit, isDoaAnswer)
    if(!isEdit && !isDoaAnswer)
      setSelectedDivisionType(undefined)
    setDivisionTypesDisabled(selectedFloor?.activePartitionTypeId)
    if(!isEdit && !isDoaAnswer && selectedFloor?.activePartitionTypeId)
      setSelectedDivisionType(selectedFloor.activePartitionType || '')
  }, [selectedFloor])

  useEffect(() => {
    if(!isEdit && !isDoaAnswer)
      setSelectedDivisionPercent(undefined)
  }, [selectedDivisionType])

  useEffect(() => {
    if(!isEdit && !isDoaAnswer)
      setPrixpartValue(0)
  }, [selectedDivisionPercent])

  useEffect(() => {
    if(percentOptions?.length === 1 && !selectedDivisionPercent && !isEdit && !isDoaAnswer)
      setSelectedDivisionPercent(percentOptions[0].value)
  }, [percentOptions?.length, selectedDivisionPercent])

  useEffect(() => {
    let limit = 100;
    let editLimit = 100;
    if(selectedBien?.contrat?.associations?.length && selectedFloor){
      for(let i in selectedBien.contrat.associations){
        if(selectedBien.contrat.associations[i].ETAGE == selectedFloor.floor){
          limit -= selectedBien.contrat.associations[i].POURCENTAGE
          if(selectedBien.contrat.associations[i].id !== idValue)
            editLimit -= selectedBien.contrat.associations[i].POURCENTAGE
        }
      }
    }
    setPercentLimitValue(limit);
    setPercentLimitEditValue(editLimit);
  }, [etageValue, idValue, selectedFloor])

  const percentChangeHandler = (e/*: ITarget*/) => {
    // let limit = 100;
    // if(selectedBien?.contrat?.associations?.length && etageValue){
    //   for(let i in selectedBien.contrat.associations){
    //     if(selectedBien.contrat.associations[i].ETAGE == etageValue.value){
    //       limit = 100 - selectedBien.contrat.associations[i].POURCENTAGE
    //       break
    //     }
    //   }
    // }
    const re = /^[0-9\b]+$/;
    if(re.test(e.target.value.toString()) && +e.target.value >= 1 && +e.target.value <= 100){
      if(+e.target.value <= percentLimitEditValue)
        setPercentValue(+e.target.value);
      else
        alert.error(`Maximum autorisé: ${percentLimitEditValue}%`);
    }
    else if(e.target.value == ""){
      setPercentValue(0);
      e.target.select();
    }
  };

  const superficieChangeHandler = (e/*: ITarget*/) => {
    const re = /^[0-9\b]+$/;
    if(re.test(e.target.value.toString()) && +e.target.value >= 1)
      setSuperficieValue(+e.target.value);
    else if(e.target.value == ""){
      setSuperficieValue(0);
      e.target.select();
    }
  };

  const handleEtageChange = data => {
    setSelectedFloor(data.value || '');
    // setEtageValue({value: data.value, label: data.value === 0 ? "RDC" : data.value} || '');
    setPercentValue(0)
  }
  const typeChangeHandler = data => {
    setTypeValue(data ? data.__isNew__ ? {name: data.value, isNew: true} : data : '');
  }
  const positionChangeHandler = (e: ITarget) => setPositionValue(e.target.value);

  const prixpartChangeHandler = (e/*: ITarget*/) => {
    const doubleValue = e.target.value ? e.target.value.toString().replace(",", ".") : 0,
      splits = doubleValue.toString().split(".");//console.log("splits", splits, doubleValue)
    if(!isNaN(doubleValue) && +doubleValue >= 0){
      const res = splits.length === 2 && splits[1] !== "" ? Number((+doubleValue).toFixed(2)) : doubleValue;
      setPrixpartValue(res);
    }
    else if(e.target.value === "")
      setPrixpartValue(0)
  };

  useEffect(() => {
    if(!prixpartFlag)
      setPrixpartFlag(true)
    else if(prixpartValue === 0 && prixpartRef?.current)
      prixpartRef.current.select()
  }, [prixpartValue]);

  useEffect(() => {
    if(!percentFlag)
      setPercentFlag(true)
    else if(percentValue === 0 && percentRef?.current)
      percentRef.current.select()
  }, [percentValue]);

  useEffect(() => {
    if(!superficieFlag)
      setSuperficieFlag(true)
    else if(superficieValue === 0 && superficieRef?.current)
      superficieRef.current.select()
  }, [superficieValue]);

  const focusHandler = (e) => {
    if(e.target.value == "0")
      e.target.select();
  };

  return (
    <Container className="CardInfo">
      <Row className="justify-content-center" style={{paddingBottom: 0}}>
        <h3>{!!isDoa ? "Étage Ciblé " : "Association"}</h3>
        {!!isDoa && <>
          <FontAwesomeIcon icon={faQuestionCircle} style={{cursor: "pointer"}} data-tip data-for="associationEtage_tooltip" />
          <ReactTooltip effect="solid" id="associationEtage_tooltip" type={"dark"}>
            Sélectionnez l'étage où mettre la réservation actuelle {/*selectedBien?.contrat?.contrat_clients?.length === 1 ? "" : "s"*/}
          </ReactTooltip>
        </>}
        {/* <div className="fullFlexCenter" style={{fontStyle: "italic", fontSize: "small"}}>Sélectionnez l'étage où mettre la réservation actuelle: <b>{(selectedBien?.contrat?.contrat_clients || []).map(e => `${e.client?.NOM || ""} ${e.client?.PRENOM}`).join(", ")}</b></div> */}
      </Row>
      {!!(selectedBien?.division && !isDoaAnswer && !isEdit) && <Row>
        <Association associations={selectedBien.contrat?.associations} etages={selectedBien.ETAGE_ASS} division={selectedBien.division} selectedFloor={selectedFloor} setSelectedFloor={setSelectedFloor} hidePartsInfo />
      </Row>}
      <Row>
        <Col xs="12" sm="4" style={{border: "none"}}>
          <FormGroup>
            <Label for="etage">Étage</Label>
            <Select
              id="etage"
              name="etage"
              className="reactselect"
              classNamePrefix="react-select"
              defaultValue={etageOptions?.length ? etageOptions[0] : ""}
              value={selectedFloor ? {value: selectedFloor, label: selectedFloor.floor === 0 ? "RDC" : selectedFloor.floor} : ''}
              onChange={handleEtageChange}
              isClearable={false}
              loadingMessage={() => 'Chargement...'}
              noOptionsMessage={() => 'pas de resultat'}
              isSearchable={false}
              options={etageOptions}                
            />
          </FormGroup>
        </Col>
        <Col xs="12" sm="4" style={{border: "none"}}>
          <FormGroup>
            <Label for="divisionType">Type répartition</Label>
            <Select
              id="divisionType"
              name="divisionType"
              className="reactselect"
              classNamePrefix="react-select"
              value={selectedDivisionType ? {value: selectedDivisionType, label: selectedDivisionType.name || "-"} : ''}
              onChange={e => setSelectedDivisionType(e.value || '')}
              isClearable={false}
              placeholder={'Type répartition...'}
              loadingMessage={() => 'Chargement...'}
              noOptionsMessage={() => 'pas de resultat'}
              isSearchable={false}
              isDisabled={!selectedBien?.division || !selectedFloor || !!selectedFloor.activePartitionTypeId}
              options={(selectedFloor?.division_floor_partition_types?.map(e => e.division_partition_type) || []).map(e => ({value: e, label: e?.name}))}
            />
          </FormGroup>
        </Col>
        <Col xs="12" sm="4" style={{border: "none"}}>
          {selectedBien?.division ? <FormGroup>
            <Label for="percent">Part</Label>
            <Select
              id="percent"
              name="percent"
              className="reactselect"
              classNamePrefix="react-select"
              value={selectedDivisionPercent ? {value: selectedDivisionPercent, label: `${selectedDivisionPercent.percent || "-"}%`} : ''}
              onChange={e => setSelectedDivisionPercent(e.value || '')}
              isClearable={false}
              placeholder={'Part...'}
              loadingMessage={() => 'Chargement...'}
              noOptionsMessage={() => 'pas de resultat'}
              isSearchable={false}
              isDisabled={!selectedDivisionType}
              options={percentOptions}
            />
          </FormGroup> : <FormGroup>
            <Label for="percent">Part ({percentLimitValue}% disponible)</Label>
            <InputGroup className="quantityInputGroup">
              <Input id="percent" placeholder="Part en pourcentage..." innerRef={percentRef} value={percentValue} onFocus={focusHandler} onChange={percentChangeHandler} />
              <InputGroupAddon addonType="append">
                <InputGroupText>%</InputGroupText>
              </InputGroupAddon>
            </InputGroup>
          </FormGroup>}
        </Col>
      </Row>
      <Row>
        <Col xs="12" sm="4" style={{border: "none"}}>
          <FormGroup>
            <Label for="type">Type</Label>
            <CreatableSelect
              id="type"
              className="reactselect"
              classNamePrefix="react-select"
              value={typeValue ? {label: typeValue["isNew"] ? typeValue["name"] : typeValue.label, value: typeValue} : null}
              onChange={typeChangeHandler}
              formatCreateLabel={(e, t) => `${e}`}
              placeholder={'Type...'}
              isClearable={true}
              loadingMessage={() => 'Chargement...'}
              noOptionsMessage={() => 'pas de resultat'}
              isSearchable={true}
              options={typeOptions}
              menuContainerStyle={{ zIndex: 9999999 }}
            />
          </FormGroup>
        </Col>
        {/* <Col xs="12" sm="6" style={{border: "none"}}>
          <FormGroup>
            <Label for="percent">Part ({percentLimitValue}% disponible)</Label>
            <InputGroup className="quantityInputGroup">
              <Input id="percent" placeholder="Part en pourcentage..." innerRef={percentRef} value={percentValue} onFocus={focusHandler} onChange={percentChangeHandler} />
              <InputGroupAddon addonType="append">
                <InputGroupText>%</InputGroupText>
              </InputGroupAddon>
            </InputGroup>
          </FormGroup>
        </Col> */}
        <Col xs="12" sm="4" style={{border: "none"}}>
          <FormGroup>
            <Label for="position">Position</Label>
            <Input id="position" type="text" placeholder="Position..." value={positionValue} onChange={positionChangeHandler} className="form-control" />
          </FormGroup>
        </Col>
        <Col xs="12" sm="4" style={{border: "none"}}>
          <FormGroup>
            <Label for="superficie">Superficie</Label>
            <InputGroup className="quantityInputGroup">
              <Input id="superficie" placeholder="Superficie..." innerRef={superficieRef} value={superficieValue} onFocus={focusHandler} onChange={superficieChangeHandler} />
              <InputGroupAddon addonType="append">
                <InputGroupText>m²</InputGroupText>
              </InputGroupAddon>
            </InputGroup>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        {!!selectedBien?.division && <Col xs="12" sm="4" style={{border: "none"}}>
          <FormGroup>
            <Label>Prix Minimum</Label>
            <InputGroup className="quantityInputGroup">
              <NumberFormat customInput={Input} disabled thousandSeparator={' '} allowNegative={false} pattern="[0-9]*" placeholder="Prix part..." value={(Number(selectedFloor?.totalPrice || 0) * Number(selectedDivisionPercent?.percent || 0)) / 100} defaultValue={0} decimalScale={2} className="form-control" />
              <InputGroupAddon addonType="append">
                <InputGroupText>DH</InputGroupText>
              </InputGroupAddon>
            </InputGroup>
          </FormGroup>
        </Col>}
        <Col xs="12" sm="4" style={{border: "none"}}>
          <FormGroup>
            <Label for="prixpart" style={{display: "flex", alignItems: "center"}}>Prix part{!!((Number(selectedFloor?.totalPrice || 0) * Number(selectedDivisionPercent?.percent || 0)) / 100) && <div style={{marginLeft: "5px", cursor: "pointer", backgroundColor: "black", color: "white", border: "1px solid #999", borderRadius: "3px", display: "flex", padding: "0 8px", alignItems: "center"}} onClick={() => setPrixpartValue((Number(selectedFloor?.totalPrice || 0) * Number(selectedDivisionPercent?.percent || 0)) / 100)}><FontAwesomeIcon icon={faArrowDown} />&nbsp;{((Number(selectedFloor?.totalPrice || 0) * Number(selectedDivisionPercent?.percent || 0)) / 100).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}</div>}</Label>
            <InputGroup className="quantityInputGroup">
              <NumberFormat customInput={Input} thousandSeparator={' '} invalid={!!selectedBien?.division && prixpartValue < (Number(selectedFloor?.totalPrice || 0) * Number(selectedDivisionPercent?.percent || 0)) / 100} allowNegative={false} id="prixpart" pattern="[0-9]*" placeholder="Prix part..." innerRef={prixpartRef} value={prixpartValue} defaultValue={0} decimalScale={2} onFocus={focusHandler} onValueChange={e => setPrixpartValue(e.value ? +e.value : 0)}/* onChange={prixpartChangeHandler}*/ className="form-control" />
              <InputGroupAddon addonType="append">
                <InputGroupText>DH</InputGroupText>
              </InputGroupAddon>
            </InputGroup>
          </FormGroup>
        </Col>
        <Col xs="12" sm={!selectedBien?.division ? "8" : "4"} style={{border: "none"}}>
          <FormGroup>
            <Label for="ass_comment">Commentaire</Label>
            <Input id="ass_comment" type="text" placeholder="Commentaire..." value={commentValue} onChange={e => setCommentValue(e.target.value)} className="form-control" />
          </FormGroup>
        </Col>
      </Row>
    </Container>
  );
};

export default connect(null, {  })(VAssociationFields);
